export default __webpack_public_path__ + "static/media/EN_01.ee608b66.svg";